import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_GalleryContent = _resolveComponent("GalleryContent")!
  const _component_GalleryTwo = _resolveComponent("GalleryTwo")!
  const _component_GalleryThree = _resolveComponent("GalleryThree")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, { PageTitle: "Gallery" }),
    _createVNode(_component_GalleryContent),
    _createVNode(_component_GalleryTwo),
    _createVNode(_component_GalleryThree)
  ], 64))
}